import { Component } from "react";
import { Link } from "react-router-dom";
import { MenuData } from "../assets/Data/MenuData";
import "../assets/styles/NavbarStyles.css";
import Logo from "../assets/images/logo.gif";
class Navbar extends Component {
  state = { clicked: false };
  handleClick = () => {
    this.setState({ clicked: !this.state.clicked });
  };
  render() {
    return (
      <nav className="NavbarItems">
        <Link className="logo-link" to="/">
          <img src={Logo} alt="Logo" />
          <h3>
            Little Champ Football Academy<span> </span>
          </h3>
        </Link>
        <div className="menu-icons" onClick={this.handleClick}>
          <i
            className={this.state.clicked ? "fas fa-times" : "fas fa-bars"}
          ></i>
        </div>
        <ul className={this.state.clicked ? "nav-menu active" : "nav-menu"}>
          {MenuData.map((item, index) => {
            return (
              <li key={index}>
                <a href={item.url} className={item.cName}>
                  <i className={item.icon}></i>
                  {item.title}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }
}
export default Navbar;
